import { render, staticRenderFns } from "./ChannelData.vue?vue&type=template&id=0b6cc231&scoped=true&"
import script from "./ChannelData.vue?vue&type=script&lang=js&"
export * from "./ChannelData.vue?vue&type=script&lang=js&"
import style0 from "./ChannelData.vue?vue&type=style&index=0&id=0b6cc231&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6cc231",
  null
  
)

export default component.exports